(() => {
  if (!document.body.classList.contains('post-type-archive-events')) {
    return;
  }

  const eventCardElements =
    document.querySelectorAll<HTMLElement>('.event-card');
  eventCardElements.forEach((eventCardElement) => {
    const eventCardTriggerElement =
      eventCardElement.querySelector<HTMLButtonElement>('.event-card__trigger');
    if (!eventCardTriggerElement || eventCardTriggerElement.disabled) return;

    eventCardTriggerElement.addEventListener('click', () => {
      eventCardElement.classList.add('event-card--open');
    });
  });

  const updateEventCardsMinHeight = () => {
    eventCardElements.forEach((eventCardElement) => {
      if (eventCardElement.classList.contains('event-card--open')) return;
      eventCardElement.style.setProperty('--min-card-height', '100%');
      eventCardElement.style.setProperty(
        '--min-card-height',
        `${eventCardElement.firstElementChild!.clientHeight}px`,
      );
    });
  };

  window.addEventListener('resize', updateEventCardsMinHeight);
  updateEventCardsMinHeight();
})();
